import React from "react";
import { Input, Typography } from "antd";
import { InputContainer } from "./styles";
import { countText, cutTextToLimit, LineBreakCount } from "../../utils/textLength";

interface TextareaComponentProps {
	title?: string;
	style?: React.CSSProperties;
	isRequired?: boolean;
	resizable?: boolean;
	value?: string | undefined;
	onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	placeholder?: string;
	error?: boolean;
	isDisabled?: boolean;
	readonly?: boolean;
	rows?: number;
	height?: string | number;
	// Shows "count / max" under the field and stops the text at max characters, counted like the backend does.
	limitCharacter?: number | undefined;
	// "crlf" when the value is sent as multipart form data: the backend gets every line break as \r\n (two characters).
	lineBreaks?: LineBreakCount;
}

const TextareaComponent = ({
	title,
	style,
	isRequired = false,
	resizable = true,
	value = "",
	onChange,
	placeholder = "",
	isDisabled,
	readonly = false,
	rows = 4,
	height,
	limitCharacter = undefined,
	lineBreaks = "lf",
}: TextareaComponentProps) => {
	return (
		<InputContainer>
			{title && (
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title}
					{isRequired && (
						<span style={{ color: "red" }}>&nbsp;*</span>
					)}
				</Typography.Title>
			)}
			<Input.TextArea
				rows={rows}
				style={{
					resize: resizable ? "vertical" : "none",
					height,
					minHeight: height,
					cursor: readonly ? "not-allowed" : "auto",
					...style,
				}}
				value={value}
				onChange={onChange}
				disabled={isDisabled}
				placeholder={placeholder}
				readOnly={readonly}
				count={limitCharacter ? {
					show: true,
					max: limitCharacter,
					strategy: text => countText(text, lineBreaks),
					exceedFormatter: (text, { max }) => cutTextToLimit(text, max, lineBreaks),
				} : undefined}
			/>
		</InputContainer>
	);
};

export default TextareaComponent;
